<template>
  <div class="details-panel panel-primary">
    <div class="header-box">
      <div class="title-box">锚点详情</div>
      <div
        class="close-icon-box"
        @click="closePanel">
        <i class="el-icon-close" />
      </div>
    </div>
    <div class="content-box">
      <div class="item-box">
        <div class="label-box">锚点名称：</div>
        <div class="value-box">{{ anchorDetails.name }}</div>
      </div>
      <div class="item-box">
        <div class="label-box">显示形式：</div>
        <div class="value-box">
          {{ anchorDetails.displayForm === 0 ? '普通锚点' : '闪烁锚点' }}
        </div>
      </div>
      <div class="item-box">
        <div class="label-box">所属组：</div>
        <div class="value-box">{{ anchorDetails.groupName }}</div>
      </div>
      <div class="item-box">
        <div class="label-box">锚点类型：</div>
        <div class="value-box">
          {{ getAnnotationType(anchorDetails) }}
        </div>
      </div>
      <div class="item-box">
        <div class="label-box">可视距离：</div>
        <div class="value-box">
          {{
            anchorDetails.visibleDistanceUnit === 'Kilometer'
              ? `${anchorDetails.visibleDistance}km`
              : `${anchorDetails.visibleDistance}m`
          }}
        </div>
      </div>
      <div class="item-box">
        <div class="label-box">近大远小：</div>
        <div class="value-box">
          {{
            anchorDetails.scalingThresholdUnit === 'Kilometer'
              ? `${anchorDetails.scalingThreshold}km`
              : `${anchorDetails.scalingThreshold}m`
          }}
        </div>
      </div>
      <div class="item-box">
        <div class="label-box">创建人：</div>
        <div class="value-box">
          {{ anchorDetails.creatorName ? anchorDetails.creatorName : '--' }}
        </div>
      </div>
      <div class="item-box">
        <div class="label-box">创建时间：</div>
        <div class="value-box">
          {{ formatTime(anchorDetails.creationTime) }}
        </div>
      </div>
      <div class="item-box">
        <div class="label-box">锚点描述：</div>
        <div class="value-box muti-line-box">
          {{ anchorDetails.description ? anchorDetails.description : '--' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatTime } from '@/utils/generalMethods'

import { getAnchorTypeListService } from '@/service/share/sceneShareInterface.js'

export default {
  data() {
    return {
      anchorTypeList: []
    }
  },
  props: {
    sceneInfo: Object,
    anchorDetails: Object
  },
  mounted() {
    this.initAnchorTypeList().then(() => {
      let anchorDetails = this.anchorDetails
      let find = this.anchorTypeList.find(
        item => item.typeId == anchorDetails.anchorPointTypeId
      )
      this.$set(anchorDetails, 'typeName', find.typeName)
    })
  },
  methods: {
    initAnchorTypeList() {
      return new Promise(resolve => {
        let projectZoneId = this.sceneInfo.projId
        let headers = this.getHeaders()
        getAnchorTypeListService({ projectZoneId }, headers).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let anchorTypeList = data.map(item => {
              item.typeName = item.name
              item.typeId = item.anchorPointTypeId
              return item
            })
            this.anchorTypeList = anchorTypeList
            resolve()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    closePanel() {
      this.$emit('closeAnchorDetailsPanel')
    },
    getAnnotationType(annotationInfo) {
      if (this.anchorTypeList.length) {
        let find = this.anchorTypeList.find(
          item => item.typeId == annotationInfo.anchorPointTypeId
        )
        return find ? find.typeName : '--'
      } else {
        this.initAnchorTypeList().then(() => {
          let anchorDetails = this.anchorDetails
          let find = this.anchorTypeList.find(
            item => item.typeId == anchorDetails.anchorPointTypeId
          )
          this.$set(anchorDetails, 'typeName', find.typeName)
        })
      }
    },
    getAnnotationSeverity(annotationInfo) {
      const severityTypeList = [
        { typeName: '一般', typeValue: 0 },
        { typeName: '中等', typeValue: 1 },
        { typeName: '严重', typeValue: 2 }
      ]
      let find = severityTypeList.find(
        item => item.typeValue === annotationInfo.severity
      )
      return find ? find.typeName : '--'
    },
    getHeaders() {
      let token = this.$route.query.token
      let headers = {
        Authorization: token
      }
      return headers
    },
    formatTime
  }
}
</script>

<style lang="less" scoped>
.details-panel {
  position: absolute;
  left: -50%;
  transform: translate(-50%, 30%);
  margin-left: -10px;
  width: 100%;
  z-index: 3;

  .header-box {
    cursor: default;
  }

  .content-box {
    padding: 16px;
    font-size: 14px;
    color: var(--default-color);

    .item-box {
      display: flex;
      margin-bottom: 16px;

      &:last-child {
        margin-bottom: 0;
      }

      .label-box {
        width: 90px;
        text-align: right;
        flex-shrink: 0;
      }

      .value-box {
        text-align: left;
      }

      .muti-line-box {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 6;
        -webkit-box-orient: vertical;
        line-height: 1.5em;
        max-height: 100px;
        overflow-y: auto;
      }
    }
  }
}
</style>
